<template>
   <!-- <img src="static/img/products/banner-dark100x50.png" width="780px" height="839px"> 
  <div class= "el-carousel__container " style="height: 839px;">-->
    <div id="dynaimage" class="el-carousel__item is_animating prod-img relative" :style="{ backgroundImage: 'url(' + productbannerimageurl + ')' }" >
        <div class="flex flex-column items-center line-height-2 mt4 pt4 absolute left-0 right-0 bottom-0" style="bottom:25%">
          <h2 class="white break-word  mt4 h4" style="">Her arbejder</h2>
          <p class="white h2 semi-bold mt1">{{ companyName }}</p>
          <p class="white h2 semi-bold mt1"><i class="el-icon-phone"></i>{{ companyTelephone }}</p>
          <p class="white h5 regular mt1"> Kunderne anbefaler os på Håndværker.dk </p>
          <div class="mt1"><image-rating  v-model="companyRating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="33" :spacing="1" :show-rating="false" :read-only="true" ></image-rating></div>
        </div>
        <div class="">
            <p>{{   }}</p>
        </div>
    </div>
 <!--</div>-->
</template>
<script>
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
export default {
  name: 'dynaimage',
  components: {
    StarRating,
    ImageRating
  },
  data () {
    return {
      show: false,
      companyName: '',
      companyTelephone: '',
      companyCvr: '',
      companyRating: '',
      haaId: '',
      salesPerson: '',
      productbannerimageurl: 'static/img/products/Byggepladshegn.png?id=' + localStorage.getItem('haaid')
    }
  },
  created () {
    if (localStorage.getItem('haaid') === '0') {
      this.show = false
    }
    this.companyRating = 4.99
    this.companyCvr = localStorage.getItem('Cvrnr')
    this.companyName = unescape(localStorage.getItem('CompanyName').replace('&#039;', '\''))
    console.log(localStorage.getItem('CompanyName'))
    this.companyTelephone = localStorage.getItem('PartnerTelefon')
    this.haaId = localStorage.getItem('haaId')
    this.salesPerson = localStorage.getItem('id_token_portalbitrix')
  },
  mounted () {
    try {
    } catch (e) {
    }
  },
  methods: {
  }
}
</script>
<style>
#dynaimage{
background-repeat: no-repeat;
background-size: 100% 100%;

}

</style>


// WEBPACK FOOTER //
// Byggepladshegn.vue?908e1ec8